/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Platform restriction for tournament participation
 * @export
 */
export const TournamentPlatform = {
    PC: 'PC',
    CONSOLE: 'CONSOLE',
    MOBILE: 'MOBILE',
    CROSS_PLATFORM: 'CROSS_PLATFORM'
} as const;
export type TournamentPlatform = typeof TournamentPlatform[keyof typeof TournamentPlatform];


export function instanceOfTournamentPlatform(value: any): boolean {
    for (const key in TournamentPlatform) {
        if (Object.prototype.hasOwnProperty.call(TournamentPlatform, key)) {
            if (TournamentPlatform[key as keyof typeof TournamentPlatform] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentPlatformFromJSON(json: any): TournamentPlatform {
    return TournamentPlatformFromJSONTyped(json, false);
}

export function TournamentPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPlatform {
    return json as TournamentPlatform;
}

export function TournamentPlatformToJSON(value?: TournamentPlatform | null): any {
    return value as any;
}

export function TournamentPlatformToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentPlatform {
    return value as TournamentPlatform;
}

